import './faq.scoped.scss';
import React, { useCallback, useEffect, useLayoutEffect } from 'react';
import AccordionList from 'src/components/AccordionList';
import { Trans, useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useAppDispatch } from 'src/AppContext';
import { chunk } from 'lodash-es';

export default function Faq(): JSX.Element {
  const { t } = useTranslation();
  const { i18n, ready } = useTranslation(['faq']);
  const [list, setList] = React.useState<Record<string, string[][]>>({});
  const [category, setCategory] = React.useState<string>();
  const [chunkList, setChunkList] = React.useState<string[][]>([]);
  const history = useCustomHistory();
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'back' });
    dispatch({
      type: 'SET_GNB_LEFT_CALLBACK',
      cb: () => {
        history.goBack();
      },
    });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'hidden' });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_LEFT_CALLBACK' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
    };
  }, []);

  useEffect(() => {
    const faqList = i18n.store.data[i18n.languages[0]].faq;
    if (faqList) {
      const orderedList = Object.entries(faqList).reduce<{
        [key: string]: string[][];
      }>((acc, cur: [string, string[]]) => {
        const categoryIds = cur[0].split('-');
        if (categoryIds && categoryIds.length > 0) {
          if (!acc['ALL']) {
            acc['ALL'] = [];
          }
          acc['ALL'].push([t('faq/all'), cur[1][1], cur[1][2]]);
          if (!acc[categoryIds[0]]) {
            acc[categoryIds[0]] = [];
          }
          acc[categoryIds[0]].push(cur[1]);
        }
        return acc;
      }, {});

      setList(orderedList);
      setChunkList(chunk(Object.keys(orderedList), 3));
      setCategory(chunk(Object.keys(orderedList), 3)[0][0]);
    }
  }, [ready, i18n.languages]);

  const onClickCategory = useCallback((e, key) => {
    e.preventDefault();
    setCategory(key);
  }, []);

  return (
    <>
      <div className="container mt-6">
        <div className="N_20_R text-black">FAQ</div>
        <div className="mt-6 border border-ice-blue rounded-sm">
          <table className="w-full">
            <thead></thead>
            <tbody>
              {chunkList.map((arr, index) => {
                return (
                  <tr key={index} className={index === chunkList.length - 1 ? '' : 'border-b'}>
                    {arr.map((key: string, index1: number) => {
                      return (
                        <td
                          key={index1}
                          className={[
                            'cursor-pointer',
                            'border-ice-blue',
                            index1 % 3 === 0 ? (index === chunkList.length - 1 ? 'rounded-bl-sm' : 'rounded-tl-sm') : '',
                            index1 % 3 === 2 ? (index === chunkList.length - 1 ? 'rounded-br-sm' : 'rounded-tr-sm') : '',
                            index1 % 3 === 1 ? 'border-l border-r' : '',
                            key === category ? 'N_12_M focus text-white' : 'N_12_R text-greyish-brown',
                          ].join(' ')}
                          style={{ width: '33.3%' }}
                          onClick={(e) => onClickCategory(e, key)}
                        >
                          <div className="relative flex items-center justify-center h-10">{list[key][0][0]}</div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="flex justify-between mt-10">
          <div className="N_14_M text-black">{category && list[category][0][0]}</div>
          <div className="flex items-center">
            <div className="N_12_R text-brown-grey">
              <Trans
                i18nKey="faq/total_count"
                components={{ span: <span className="N_12_M text-bluey-purple flex-none" /> }}
                values={{ count: category && list[category] ? list[category].length : list.length }}
              ></Trans>
            </div>
          </div>
        </div>
        <div className="mt-4">{list && category && list[category] && <AccordionList list={list[category]} />}</div>
      </div>
    </>
  );
}
